export const TABLE_ROWS = 5

export const TABLE_CELLS = 3
